import { createAppHistory } from './utils/createAppHistory';

export const appHistory = createAppHistory();
